import { render, staticRenderFns } from "./TheNavigationDrawerHeader.vue?vue&type=template&id=a3b0a5bc&scoped=true&"
import script from "./TheNavigationDrawerHeader.vue?vue&type=script&lang=ts&"
export * from "./TheNavigationDrawerHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b0a5bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
